module.exports = __webpack_public_path__ + "img/7.76884ca5.jpg";